import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cms-general-expansion-system",
  "use": "icon-cms-general-expansion-system-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-cms-general-expansion-system\"><path d=\"M110,199.47,32.52,154.73V65.27L110,20.53l77.48,44.74v89.46ZM41.52,149.54,110,189.08l68.48-39.54V70.46L110,30.92,41.52,70.46Z\" /><polygon points=\"110 112.8 68.56 88.87 73.06 81.08 110 102.4 146.94 81.08 151.44 88.87 110 112.8\" /><rect x=\"105.5\" y=\"107.6\" width=\"9\" height=\"41.38\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol